import * as React from "react";
import { failed_login, RefreshFieldsScreen, handleFileQueueClick } from "../actions/navigationWorker";
import { Icon } from "@fluentui/react/lib/Icon";
import { IconButton } from "@fluentui/react/lib/Button";
import { Callout, DirectionalHint } from "@fluentui/react/lib/Callout";
import { addCurrentEmailToQueue, getQueueCount, getQueuedEmails, removeFromQueue, clearQueue, QueuedEmail } from "../actions/queueWorker";
import { formatDate } from "../actions/helper";

class Logo extends React.Component<any, any> {
	private _queueButtonRef = React.createRef<HTMLButtonElement>();

	constructor(props: any) {
		super(props);
		this.state = {
			queueCount: getQueueCount(),
			showMessage: false,
			message: "",
			messageType: "success",
			showQueueDropdown: false,
		};
	}

	componentDidMount() {
		window.addEventListener("queueUpdated", this.handleQueueUpdate);
	}

	componentWillUnmount() {
		window.removeEventListener("queueUpdated", this.handleQueueUpdate);
	}

	handleQueueUpdate = () => {
		this.setState({ queueCount: getQueueCount() });
	};

	Logout = () => {
		clearQueue(); // Clear email queue on logout
		failed_login("", true);
		localStorage.removeItem("is_sso_login");
		localStorage.removeItem("user_name");
	};

	Settings = () => {
		RefreshFieldsScreen();
	};

	Home = () => {
		location.reload();
	};

	AddToQueue = () => {
		const result = addCurrentEmailToQueue();
		if (result.success) {
			this.setState({
				showMessage: true,
				message: result.message,
				messageType: "success",
			});
		} else {
			this.setState({
				showMessage: true,
				message: result.message,
				messageType: result.isAlreadyQueued ? "warning" : "error",
			});
		}

		// Hide message after 3 seconds
		setTimeout(() => {
			this.setState({ showMessage: false });
		}, 3000);
	};

	toggleQueueDropdown = () => {
		this.setState({ showQueueDropdown: !this.state.showQueueDropdown });
	};

	closeQueueDropdown = () => {
		this.setState({ showQueueDropdown: false });
	};

	handleRemoveFromQueue = (itemId: string) => {
		removeFromQueue(itemId);
		// State will update via queueUpdated event
	};

	handleFileQueue = () => {
		this.closeQueueDropdown();
		handleFileQueueClick();
	};

	render() {
		if (this.props.hide || this.props.login) {
			return null;
		}

		const bannerStyle = { 
			position: "fixed" as "fixed",
			top: 0,
			left: 0,
			right: 0,
			width: "100%",
			height: "45px", 
			display: "flex", 
			alignItems: "center", 
			justifyContent: "flex-end",
			paddingLeft: "4px",
			paddingRight: "4px",
			gap: "4px",
			backgroundColor: "#5D3FD6",
			zIndex: 100
		};

		const buttonStyle: React.CSSProperties = {
			backgroundColor: "#5D3FD6",
			color: "#ffffff",
			height: "36px",
			width: "36px",
			minWidth: "36px",
			borderRadius: "6px",
			border: "none",
			cursor: "pointer",
			fontSize: "16px",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			transition: "all 0.2s",
			boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
		};

		return (
			<div style={bannerStyle}>
				{this.state.showMessage && (
					<div
						style={{
							position: "fixed",
							top: "50px",
							left: "50%",
							transform: "translateX(-50%)",
							padding: "8px 16px",
							borderRadius: "4px",
							backgroundColor:
								this.state.messageType === "success"
									? "#107C10"
									: this.state.messageType === "warning"
									? "#F7630C"
									: "#D13438",
							color: "#ffffff",
							fontSize: "13px",
							zIndex: 1000,
							boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
						}}
					>
						{this.state.message}
					</div>
				)}
				<button
					data-automation-id="btnAddToQueue"
					title="Add current email to queue"
					onClick={this.AddToQueue}
					style={{
						...buttonStyle,
						position: "relative",
					}}
					onMouseEnter={(e) => {
						e.currentTarget.style.backgroundColor = "#4A2FC7";
						e.currentTarget.style.transform = "scale(1.05)";
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.backgroundColor = "#5D3FD6";
						e.currentTarget.style.transform = "scale(1)";
					}}
				>
					<Icon iconName="Mail" style={{ fontSize: "18px" }} />
					<Icon iconName="CirclePlus" style={{ fontSize: "10px", position: "absolute", bottom: "6px", right: "6px" }} />
					{this.state.queueCount > 0 && (
						<span
							style={{
								position: "absolute",
								top: "-4px",
								right: "-4px",
								backgroundColor: "#D13438",
								color: "#ffffff",
								borderRadius: "10px",
								padding: "2px 6px",
								fontSize: "11px",
								fontWeight: "bold",
								minWidth: "18px",
								textAlign: "center",
							}}
						>
							{this.state.queueCount}
						</span>
					)}
				</button>
				{this.state.queueCount > 0 && (
					<>
						<button
							ref={this._queueButtonRef}
							data-automation-id="btnToggleQueue"
							title="View queue"
							onClick={this.toggleQueueDropdown}
							style={{
								...buttonStyle,
								width: "24px",
								minWidth: "24px",
								marginLeft: "-2px",
								fontSize: "12px",
							}}
							onMouseEnter={(e) => {
								e.currentTarget.style.backgroundColor = "#4A2FC7";
								e.currentTarget.style.transform = "scale(1.05)";
							}}
							onMouseLeave={(e) => {
								e.currentTarget.style.backgroundColor = "#5D3FD6";
								e.currentTarget.style.transform = "scale(1)";
							}}
						>
							<Icon iconName={this.state.showQueueDropdown ? "ChevronUp" : "ChevronDown"} />
						</button>
						{this.state.showQueueDropdown && (
							<Callout
								target={this._queueButtonRef.current}
								onDismiss={this.closeQueueDropdown}
								directionalHint={DirectionalHint.bottomLeftEdge}
								styles={{
									root: {
										maxWidth: "400px",
										width: "90vw",
									},
								}}
							>
								<div style={{ padding: "12px" }}>
									<div style={{ 
										display: "flex", 
										justifyContent: "space-between", 
										alignItems: "center",
										marginBottom: "12px",
										paddingBottom: "8px",
										borderBottom: "2px solid #5D3FD6"
									}}>
										<h3 style={{ 
											margin: 0, 
											fontSize: "14px",
											color: "#1A1F4D",
											fontWeight: 600
										}}>
											Email Queue ({this.state.queueCount})
										</h3>
									</div>
									<div
										style={{
											maxHeight: "300px",
											overflowY: "auto",
										}}
									>
										{getQueuedEmails().map((email: QueuedEmail) => (
											<div
												key={email.itemId}
												style={{
													padding: "8px",
													marginBottom: "4px",
													backgroundColor: "#f9f9f9",
													borderRadius: "4px",
													border: "1px solid #e1dfdd",
												}}
											>
												<div style={{ 
													display: "flex", 
													justifyContent: "space-between",
													alignItems: "flex-start"
												}}>
													<div style={{ flex: 1, marginRight: "8px" }}>
														<div style={{ 
															fontWeight: 500, 
															marginBottom: "4px",
															fontSize: "12px"
														}}>
															{email.subject || "(No Subject)"}
														</div>
														<div style={{ 
															color: "#605e5c", 
															fontSize: "11px",
															marginBottom: "2px"
														}}>
															From: {email.senderEmail}
														</div>
														<div style={{ 
															color: "#605e5c", 
															fontSize: "11px"
														}}>
															{formatDate(new Date(email.dateTimeCreated))}
														</div>
													</div>
													<IconButton
														iconProps={{ iconName: "Cancel" }}
														title="Remove from queue"
														onClick={() => this.handleRemoveFromQueue(email.itemId)}
														styles={{
															root: {
																height: "24px",
																width: "24px",
															},
														}}
													/>
												</div>
											</div>
										))}
									</div>
								</div>
							</Callout>
						)}
					</>
				)}
				<button
					data-automation-id="btnHome"
					title="Home"
					onClick={this.Home}
					style={buttonStyle}
					onMouseEnter={(e) => {
						e.currentTarget.style.backgroundColor = "#4A2FC7";
						e.currentTarget.style.transform = "scale(1.05)";
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.backgroundColor = "#5D3FD6";
						e.currentTarget.style.transform = "scale(1)";
					}}
				>
					<Icon iconName="Home" />
				</button>
				<button
					data-automation-id="btnSettings"
					title="Settings"
					onClick={this.Settings}
					style={buttonStyle}
					onMouseEnter={(e) => {
						e.currentTarget.style.backgroundColor = "#4A2FC7";
						e.currentTarget.style.transform = "scale(1.05)";
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.backgroundColor = "#5D3FD6";
						e.currentTarget.style.transform = "scale(1)";
					}}
				>
					<Icon iconName="Settings" />
				</button>
				<button
					data-automation-id="btnLogout"
					title="Logout"
					onClick={this.Logout}
					style={buttonStyle}
					onMouseEnter={(e) => {
						e.currentTarget.style.backgroundColor = "#4A2FC7";
						e.currentTarget.style.transform = "scale(1.05)";
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.backgroundColor = "#5D3FD6";
						e.currentTarget.style.transform = "scale(1)";
					}}
				>
					<Icon iconName="SignOut" />
				</button>
				<div style={{ width: "8px" }}></div>
			</div>
		);
	}
}

export default Logo;
